import CertifiedFieldFormValue from "../ReusableFormValues/CertifiedFieldFormValue";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { organizationalDocumentTypesArray } from "./constants";

export type Props = {
  readonly: boolean;
  documentName?: string;
};

const OrganizationalDocFormValues = ({ readonly, documentName = "" }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={organizationalDocumentTypesArray}
        placeholder="Select an organizational document type"
        name="secondaryDocumentType"
        label="Document sub-type"
        documentName={documentName}
      />
      <CertifiedFieldFormValue readonly={readonly} />
    </>
  );
};

export default OrganizationalDocFormValues;
